import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

/** Keeps the Google sign-in SDK off the homepage entry bundle. */
class GoogleAuthBoundary extends React.Component {
  render() {
    return (
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
        {this.props.children}
      </GoogleOAuthProvider>
    );
  }
}

export default GoogleAuthBoundary;
